import { openMenu } from "../menu/menu";
import { pluginConfig } from "@/globals/pluginConfig";
import { LANGUAGE_DICTIONARY } from "@/i18n/Languages";
import { getDefaultLanguage } from "@/i18n/getDefaultLanguage";
import { getShortcutLabel } from "@/utils/getShortcutLabel";
import { renderButton, getWidgetEl, ICON_LIBRARY } from "./renderButton";

export { ICON_LIBRARY, getWidgetEl };

export let $widget: HTMLElement | null = null;

/**
 * Plugin/full-bundle entry: everything is in one bundle, so the button label
 * is translated here and activation opens the menu directly.
 */
export function renderWidget(): HTMLElement | null {
  try {
    const defaultLanguage = getDefaultLanguage();
    const baseLabel =
      LANGUAGE_DICTIONARY[defaultLanguage]?.[pluginConfig.label] || "Accessibility menu";
    const shortcutHint =
      pluginConfig.keyboard?.enabled && pluginConfig.keyboard.shortcut
        ? ` — Press ${getShortcutLabel(pluginConfig.keyboard.shortcut)} to open/close`
        : "";

    $widget = renderButton({
      config: pluginConfig,
      label: `${baseLabel}${shortcutHint}`,
      onActivate: openMenu,
    });
    return $widget;
  } catch (error) {
    console.error("Failed to render widget:", error);
    return null;
  }
}
